import { DesktopNotificationSetting, NotificationSettingValue } from '../utils/Constants';
import { changeDesktopNotificationSetting } from '../mutators/changeDesktopNotificationSetting';
import { logUsage } from 'owa-analytics';
import saveDesktopNotificationSetting from './saveDesktopNotificationSetting';

export function setDesktopNotificationSetting(
    desktopSettingKey: DesktopNotificationSetting,
    value: NotificationSettingValue
) {
    changeDesktopNotificationSetting(desktopSettingKey, value);
    logUsage('NativeNotificationSettingsValueChanged', {
        settingName: desktopSettingKey,
        newValue: value,
    });
    saveDesktopNotificationSetting();
}
